module.exports = function () {
    $('.topic-and-tag-footer-list__item-title').click(function (e) {
        e.preventDefault();

        if (ICF.Utils.Breakpoints.IsMobile()) {
            var $groupToToggle = $(this).siblings('.topic-and-tag-footer-list__item-content').first();

            var $icon = $(this).find('.circle-plus-minus-icon');

            if ($icon.hasClass('circle-plus-minus-icon--is-active')) {
                $icon.removeClass('circle-plus-minus-icon--is-active');
                $groupToToggle.css({
                    height: '0px'
                });
            }
            else {
                var height = 0;
                $groupToToggle.find('li').each(function (i) {
                    height += $(this).outerHeight(true);
                });

                $icon.addClass('circle-plus-minus-icon--is-active');
                $groupToToggle.css({
                    height: height + 'px'
                });
            }

            $(this).attr('aria-expanded', function (i, attr) {
                return attr === 'true' ? 'false' : 'true'
            });
        }
    });

    var resetTopicAndTagHeights = function () {
        if (window.innerWidth > 767) {
            $('.topic-and-tag-footer-list__item-content').css({
                height: ''
            });

            $('.topic-and-tag-footer-list__item-title .circle-plus-minus-icon').removeClass('circle-plus-minus-icon--is-active');
        }
    };

    $(window).resize(function () {
        requestAnimationFrame(resetTopicAndTagHeights);
    });
};